import http from "../axios/http-common";

class InterfaceAsesmenRisikoJatuh {
  getAsesmenRisikoJatuh(unit, reg) {
    return http.getData(`/asesmen-risiko-jatuh-ralan/unit/${unit}/register/${reg}`);
  }
  getRiwayatAsesmenRisikoJatuh(rm) {
    return http.getData(`/asesmen-risiko-jatuh-ralan/pasien/${rm}`);
  }

  saveAsesmenRisikoJatuh(reg, rm, unit_id, petugas_id, risiko, waktu_periksa) {
    return http.postData(`/asesmen-risiko-jatuh-ralan`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      petugas_id: petugas_id,
      risiko: risiko,
      waktu_periksa: waktu_periksa,
    });
  }

  editAsesmenRisikoJatuh(id, petugas_id, risiko, waktu_periksa) {
    return http.putData(`/asesmen-risiko-jatuh-ralan/${id}`, {
      petugas_id: petugas_id,
      risiko: risiko,
      waktu_periksa: waktu_periksa,
    });
  }
}
export default new InterfaceAsesmenRisikoJatuh();
